/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@coursera/cds-core';
import { ArrowPreviousIcon } from '@coursera/cds-icons';
import { useTracker } from '@coursera/event-pulse/react';

import _t from 'i18n!nls/reviews';

type Props = {
  courseName: string;
  href: string;
};

const styles = {
  backButton: css`
    margin-top: var(--cds-spacing-300);
    max-width: none;
  `,
};

const ReviewsBackButton = ({ courseName, href }: Props) => {
  const track = useTracker();

  return (
    <Button
      component="a"
      css={styles.backButton}
      edgeAlign="start"
      href={href}
      icon={<ArrowPreviousIcon />}
      iconPosition="before"
      onClick={() => {
        track('click_button', {
          button: {
            name: 'reviews_back_to_xdp',
          },
        });
      }}
      size="small"
      variant="ghost"
    >
      <FormattedMessage message={_t('Back to {courseName}')} courseName={courseName} />
    </Button>
  );
};

export default ReviewsBackButton;
